import Cookies from 'universal-cookie';
var getCookie = function getCookie(name) {
  var cookies = new Cookies();
  return cookies.get(name);
};
export default getCookie;